import { render, staticRenderFns } from "./domains.vue?vue&type=template&id=03ebbf74&"
import script from "./domains.vue?vue&type=script&lang=js&"
export * from "./domains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports